import Axios from 'utils/axios'
import {convertJSON} from "utils/helper";

export default {
	namespaced: true,
	state: {
		data: null,
		list: [],
		page: 1,
		pageSize: 10,
		total: 0,
		condition: {}
	},
	mutations: {
		update(state, payload) {
			Object.assign(state, payload)
		}
	},
	actions: {
		fetch({commit, state}, payload) {
			const promise = Axios.get('/admin/template/resizeTemplateList', {
				params: {
					...state.condition,
					...payload,
					page: state.page,
					pageSize: state.pageSize
				}
			})
			promise.then(function (res) {
				commit('update', {
					list: res.list || [],
					total: res.total || 0
				})
			})
			return promise
		},
		fetchOne({commit, state}, {id}) {
			const promise = Axios.get('/admin/template/resizeTemplateDetail', {
				params: {
					id
				}
			})
			promise.then(function (res) {
				commit('update', {
					data: res
				})
				const keys = Object.keys(res.content)

				if (keys.length) {
					let tpl = {}
					keys.forEach((keyName)=>{
						tpl[keyName] = {
							...res.content[keyName],
							list: (res.content[keyName].list || []).map((item) => {
								const {minPoint, maxPoint, rotate = 0, ...data} = item
								const width = maxPoint.x - minPoint.x
								const height = maxPoint.y - minPoint.y
								return {
									id: Math.random(),
									width,
									height,
									x: minPoint.x + width/2,
									y: minPoint.y + height/2,
									rotate,
									...data
								}
							})
						}
					})

					commit('update', {
						canvas: tpl[keys[0]].list||[],
						tpl,
						keys,
						selected:{},
						activeKey: keys[ 0 ],
						scaleRate: 500/tpl[keys[0]].height,
						designWidth: tpl[keys[0]].width,
						designHeight: tpl[keys[0]].height
					}, {
						root: true
					})
				} else {
					commit('update', {
						selected:{},
						canvas: [],
						tpl: null,
						keys,
						activeKey: null,
						designWidth: 0,
						designHeight: 0
					}, {
						root: true
					})
				}

				commit('set_history', {
					canvas: []
				}, {
					root: true
				})

			})
			return promise
		},
		create({commit, dispatch, state}, payload) {
			return Axios.post('/admin/template/saveResize', payload)
		},
		save({commit, dispatch, state}, payload) {
			dispatch('elm_unselect', null, {root: true})
			return Axios.post('/admin/template/saveResize', {
				...payload
			})
		},
		delete({commit, state}, {ids}) {
			return Axios.post('/admin/template/deleteResizeTemplate', {
				ids
			})
		},
		activate({commit, state}, {ids, isOpen}) {
			return Axios.post('/admin/template/openResizeTemplate', {
				ids, isOpen
			})
		}
	}
}
